import { useState } from 'react'
import { Input } from '~/shared/ui/input'
import { FormField } from './form-field'

interface FormInputProps {
  // biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API is dynamically typed
  field: any
  label: string
  type?: string
  placeholder?: string
  optional?: boolean
  maxLength?: number
  min?: number
  max?: number
}

export function FormInput({
  field,
  label,
  type = 'text',
  placeholder,
  optional,
  maxLength,
  min,
  max,
}: FormInputProps) {
  const [hasBlurred, setHasBlurred] = useState(false)

  return (
    <FormField field={field} label={label} optional={optional} hasBlurred={hasBlurred}>
      <Input
        id={field.name}
        name={field.name}
        type={type}
        value={field.state.value || ''}
        onBlur={() => {
          setHasBlurred(true)
          field.handleBlur()
        }}
        onChange={(e) =>
          field.handleChange(type === 'number' ? Number(e.target.value) : e.target.value)
        }
        placeholder={placeholder}
        maxLength={maxLength}
        min={min}
        max={max}
      />
    </FormField>
  )
}
